import { ArrowLeftOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Input, Progress, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { ICON } from './icon';
import UserManagementService from '../../services/UserManagement.service';
import UserService from '../../services/UserService';
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';

export default function Yourplan() {
    const { t } = useTranslation();

    const [userDetail, setUserDetail] = useState();
    const [suggestion, setSuggestion] = useState();
    const [isConfirmSave, setIsConfirmSave] = useState(false);

    const id = UserService.getUi();
    const startDate = UserService.getStartDate();
    const endDate = UserService.getEndDate();
    const active = UserService.currentPackage();

    useEffect(() => {
        const getUserDetail = async () => {
            try {
                const { data } = await UserManagementService.getUserDetail(id);
                const item = data?.resultData;
                setUserDetail(item);
            } catch (error) {
                console.log(error);
            }
        };
        getUserDetail();
    }, [id]);

    const onSaveSuggestion = async () => {
        if (!suggestion) return;
        try {
            const { data } = await UserManagementService.submitSuggestion({
                comment: suggestion,
            });
            if (data?.resultCode === 1) {
                setSuggestion('');
                setIsConfirmSave(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const storageUsageBase = Number(userDetail?.storageUsage || 0);
    const storageUsageMap = {
        1: 0.5,
        2: 3,
        3: 3,
        4: 4,
    };
    const storageUsage = storageUsageBase + (storageUsageMap[active] || 0);

    const statusColor = userDetail?.userStatus ? '#4ACE8F' : '#FF4D4F';
    const maximumUsage = userDetail?.maximumUsage || 0;
    const percentage = (storageUsage / maximumUsage) * 100;

    return (
        <div>
            <div className="title ">{t('Your Plan')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} /
                </span>
                <span> {t('Your Plan')} </span>
            </div>
            <div className="grid grid-cols-2 gap-4 mt-4">
                <div className="bg-white p-4 rounded-lg">
                    <div className="text-2xl font-semibold">
                        {parse(t('Your WhiteFact Plan'))}
                    </div>
                    <div className="bg-[#F3F9FF] p-4 mt-4 rounded-lg space-y-2">
                        <div className="grid grid-cols-3">
                            <div className="col-span-1 font-semibold">
                                {t('Current Plan')} :
                            </div>
                            <div className="flex items-center gap-2 col-span-2">
                                {userDetail?.packageName}{' '}
                                <Tag
                                    className={`bg-[${statusColor}] text-white border-none rounded-full`}
                                >
                                    {userDetail?.userStatusName}
                                </Tag>
                            </div>
                        </div>
                        <div className="grid grid-cols-3">
                            <div className="col-span-1 font-semibold">
                                {t('Effective Date')} :
                            </div>
                            <div className="col-span-2">
                                {startDate} - {endDate}
                            </div>
                        </div>
                        <div className="grid grid-cols-3">
                            <div className="col-span-1 font-semibold">
                                {t('Renews in')} :
                            </div>
                            <div className="col-span-2">
                                {userDetail?.dayLeft || 0} {t('Days')}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-4 rounded-lg pl-6">
                    <div className="text-2xl font-semibold">
                        {t('Your Storage')}
                    </div>
                    <div className="text-lg font-semibold">
                        {storageUsage?.toFixed(2)} GB {t('of')} {maximumUsage}{' '}
                        GB {t('used')}
                    </div>
                    <Progress
                        className="my-2"
                        strokeColor={{
                            '0%': '#C2BAFF',
                            '100%': '#7B67FB',
                        }}
                        strokeWidth={12}
                        percent={percentage.toFixed(1)}
                    />
                    <div className="text-[#65707A]">
                        {t('This is an overview')}
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4">
                <div className="grid grid-cols-2">
                    <div
                        className="col-span-1 pr-6"
                        style={{
                            borderRight: '1px solid #ECECEC',
                        }}
                    >
                        <div className="text-center w-full font-semibold text-2xl">
                            {t('Suggestion for Better Experience')}
                        </div>
                        {isConfirmSave ? (
                            <div className="h-80 flex flex-col items-center justify-center">
                                {ICON.Thank}
                                <div className="text-lg font-semibold mt-4 text-purple-PHX">
                                    {t('Thank you for your feedback')}
                                </div>
                                <div className="text-center mt-4">
                                    <Button
                                        onClick={() =>
                                            setIsConfirmSave(!isConfirmSave)
                                        }
                                        size="large"
                                        type="primary"
                                        icon={<ArrowLeftOutlined />}
                                    >
                                        {t('Back')}
                                    </Button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <p className="font-semibold mt-4">
                                    {t('Tell us about')}
                                </p>
                                <Input.TextArea
                                    placeholder={t('Comment...')}
                                    rows={10}
                                    showCount
                                    maxLength={500}
                                    value={suggestion}
                                    onChange={(e) =>
                                        setSuggestion(e.target.value)
                                    }
                                />
                                <div className="text-center mt-4">
                                    <Button
                                        onClick={onSaveSuggestion}
                                        size="large"
                                        type="primary"
                                        icon={<MailOutlined />}
                                    >
                                        {t('Submit_Comment')}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-span-1 pl-6 p-4 relative">
                        <div className="text-2xl font-semibold">
                            {t('Contact Us')}
                        </div>
                        <div className="space-y-2 mt-4">
                            <div className="flex items-start gap-2">
                                {ICON.Tel}
                                <span className="mt-2">
                                    02-781-9333 ({t('Working day')})
                                </span>
                            </div>
                            <div className="flex items-start gap-2">
                                {ICON.Mess}
                                <a
                                    href="mailto:whitefact.support@g-able.com"
                                    className="mt-2 text-[#1890FF] underline"
                                >
                                    whitefact.support@g-able.com
                                </a>
                            </div>
                            <div className="flex items-start gap-2">
                                {ICON.Web}
                                <a
                                    href="https://www.whitefact.co"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="mt-2 text-[#1890FF] underline"
                                >
                                    www.whitefact.co
                                </a>
                            </div>
                        </div>
                        <div className="absolute bottom-0 right-0">
                            {ICON.Image}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
